import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { authApi } from "../api/authApi";

export default function Layout({ user, cartCount = 0, children, onCartUpdate, onUserUpdate }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  async function handleLogout() {
    try {
      await authApi.logout();
      setMenuOpen(false);
      onUserUpdate(null); // Clear user state
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  }

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <Link to="/" onClick={closeMenu}>IoTBay</Link>
          </div>

          <div 
            className="hamburger" 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
            <li className="nav-item">
              <NavLink to="/" className="nav-link" onClick={closeMenu}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/shop" className="nav-link" onClick={closeMenu}>Shop</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/cart" className="nav-link" onClick={closeMenu}>
                Cart <span className="cart-count">{cartCount}</span>
              </NavLink>
            </li>

            {user ? (
              <>
                {user.role === "admin" ? (
                  <li className="nav-item">
                    <NavLink to="/admin-dashboard" className="nav-link" onClick={closeMenu}>Admin Panel</NavLink>
                  </li>
                ) : (
                  <>
                    <li className="nav-item">
                      <NavLink to="/account-settings" className="nav-link" onClick={closeMenu}>My Account</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/payment-methods" className="nav-link" onClick={closeMenu}>Payments</NavLink>
                    </li>
                  </>
                )}
                <li className="nav-item">
                  <button type="button" className="nav-link" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <NavLink to="/login" className="nav-link" onClick={closeMenu}>Login</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/signup" className="nav-link signup-link" onClick={closeMenu}>Sign Up</NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </nav>

      <main>{children}</main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About IoTBay</h3>
            <p>Your one-stop destination for quality products at great prices.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/cart">Cart</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>Email: support@iotbay.com</p>
            <p>Phone: +1 (800) 123-4567</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 IoTBay. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
}
